import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { NAV, SITE } from "../data/nav";

export const SiteHeader = () => {
  const [open, setOpen] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white border-b hairline" data-testid="site-header">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 h-[68px] flex items-center justify-between gap-6">
        <a href={SITE.home} className="flex items-center shrink-0" data-testid="header-logo-link">
          <img src={SITE.logo} alt="GDPR Local" className="h-[38px] w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center" data-testid="header-nav">
          {NAV.map((item) => (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => item.items && setOpen(item.label)}
              onMouseLeave={() => setOpen(null)}
            >
              {item.href ? (
                <a
                  href={item.href}
                  className="px-3 py-2 text-[15px] font-medium text-asphalt hover:text-aqua transition-colors"
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  {item.label}
                </a>
              ) : (
                <button
                  className="px-3 py-2 text-[15px] font-medium text-asphalt hover:text-aqua transition-colors inline-flex items-center gap-1"
                  data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {item.label}
                  <ChevronDown size={15} className={`transition-transform ${open === item.label ? "rotate-180" : ""}`} />
                </button>
              )}
              {item.items && open === item.label && (
                <div className="absolute left-1/2 -translate-x-1/2 top-full pt-2">
                  <div className="w-[280px] bg-white border hairline rounded-lg shadow-xl py-2">
                    {item.items.map((sub) => (
                      <a
                        key={sub.label}
                        href={sub.href}
                        className="block px-4 py-2 text-[14px] text-asphalt hover:bg-asphalt-tint hover:text-aqua transition-colors"
                      >
                        {sub.label}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3 shrink-0">
          <a href={SITE.signIn} className="text-[15px] font-medium text-asphalt hover:text-aqua transition-colors" data-testid="header-signin">
            Sign in
          </a>
          <a href={SITE.contactSales} className="btn-outline px-4 py-2 text-[14px]" data-testid="header-contact-sales">
            Contact sales
          </a>
          <a href={SITE.signUp} className="btn-aqua px-4 py-2 text-[14px]" data-testid="header-signup">
            Sign up free
          </a>
        </div>

        <button
          className="lg:hidden text-asphalt p-2"
          onClick={() => setMobileOpen((v) => !v)}
          data-testid="header-mobile-toggle"
          aria-label="Menu"
        >
          <div className="space-y-1.5">
            <span className="block w-6 h-0.5 bg-asphalt" />
            <span className="block w-6 h-0.5 bg-asphalt" />
            <span className="block w-6 h-0.5 bg-asphalt" />
          </div>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t hairline bg-white max-h-[70vh] overflow-y-auto thin-scroll" data-testid="header-mobile-menu">
          <div className="px-5 py-4 space-y-4">
            {NAV.map((item) => (
              <div key={item.label}>
                {item.href ? (
                  <a href={item.href} className="block font-medium text-asphalt py-1">{item.label}</a>
                ) : (
                  <>
                    <div className="font-bold text-asphalt py-1">{item.label}</div>
                    <div className="pl-3 space-y-1">
                      {item.items.map((sub) => (
                        <a key={sub.label} href={sub.href} className="block text-[14px] text-mutedink py-0.5">{sub.label}</a>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ))}
            <div className="flex flex-col gap-2 pt-2 border-t hairline">
              <a href={SITE.signIn} className="font-medium text-asphalt py-1">Sign in</a>
              <a href={SITE.contactSales} className="btn-outline px-4 py-2 text-center">Contact sales</a>
              <a href={SITE.signUp} className="btn-aqua px-4 py-2 text-center">Sign up free</a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
